export const iconFontAwesomeEditingScissors = (
	<i className="fa-solid fa-scissors"></i>
);
